<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-data-table :loading="carregando ? 'success' : null" no-data-text="Nenhum Bloqueio de Horário encontrado!"
          loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunasBloqueios"
          :header-props="headerProps" :items="listaBloqueiosFiltradosPaginados" :items-per-page="itensPorPagina"
          :page.sync="paginaAtual" hide-default-footer class="elevation-0">
          <template v-slot:top>
            <v-row>
              <v-col class="botao-novo" cols="12" sm="12" md="4">
                <v-btn class="btn-novo-bloqueio" @click="abrirModalBloqueios()">
                  <v-icon>mdi-plus</v-icon>
                  NOVO
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <soi-select v-model="tipoBloqueioFiltro" :items="optionsTipoBloqueioFiltro" label="Filtrar por Tipo"
                  clearable>
                </soi-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <soi-select v-model="itensPorPagina" :items="quantidadeItens" label="Itens por Página">
                </soi-select>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.tipoBloqueio="{ item }">
            {{ formatarTipoBloqueio(item.tipoBloqueio) }}
          </template>
          <template v-slot:item.data="{ item }">
            {{ formatarData(item.data) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="mx-2" x-small fab color="success" @click="abrirModalBloqueiosParaEdicao(item)"
              title="Editar Bloqueio">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="mx-2" x-small fab color="error" @click="excluirBloqueio(item)" title="Excluir Bloqueio">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-row class="mt-2">
          <v-col cols="12">
            <v-pagination v-model="paginaAtual" :length="totalPaginas" next-icon="$arrowright" prev-icon="$arrowleft"
              color="success" :total-visible="5">
            </v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="modalBloqueios" max-width="900px" class="bloqueio-modal">
      <div class="bloqueio-modal-container">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon class="header-icon-white">{{ iconeTituloBloqueios }}</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">{{ tituloBloqueios }}</h2>
                <p class="header-subtitle">Configure os bloqueios de horário específicos da agenda</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <validation-observer ref="observerBloqueios" v-slot="{ }">
                <v-form>
                  <v-row>
                    <v-col cols="12" md="6" sm="12">
                      <soi-select :name="'Tipo do Bloqueio'" v-model="bloqueio.tipoBloqueio"
                        :label="'Tipo do Bloqueio *'" :rules="{ required: true }" :items="optionsTipoBloqueio">
                      </soi-select>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <soi-input type="date" :name="'Data'" v-model="bloqueio.data" :label="'Data *'"
                        :rules="{ required: true }">
                      </soi-input>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <soi-input type="time" :name="'Horário de Início'" v-model="bloqueio.horarioInicio"
                        :label="'Horário de Início *'" :rules="{ required: true }">
                      </soi-input>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <soi-input type="time" :name="'Duração'" v-model="bloqueio.duracao" :label="'Duração *'"
                        :rules="{ required: true }">
                      </soi-input>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <validation-provider v-slot="{ errors }" name="Descrição" :rules="regrasDescricao">
                        <v-textarea v-model="bloqueio.descricao"
                          :label="bloqueio.tipoBloqueio === 6 ? 'Descrição / Observação *' : 'Descrição / Observação'"
                          placeholder="Informe o motivo do bloqueio" rows="3" outlined dense color="success"
                          :error-messages="errors" counter maxlength="45">
                        </v-textarea>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-form>
              </validation-observer>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando" :disabled="carregando">
                  <v-icon left>$saveIcon</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import { AlertaExclusaoQuestaoBooleano, MensagemMixin } from '../../helpers/MensagemHelper';
import BloqueioHorarioEspecifico from '../../models/agenda/BloqueioHorarioEspecifico';
import { TipoBloqueioHorario, TipoBloqueioHorarioLabels } from '../../models/enums/EnumTipoBloqueioHorario';

export default Vue.extend({
  name: 'soi-bloqueioHorarioEspecificoAgenda',
  props: {
    value: {
      type: Array as () => BloqueioHorarioEspecifico[],
      required: true,
    },
    agenda: {
      type: Object as () => any,
      required: false,
      default: null,
    },
  },
  watch: {
    value: {
      handler(newValue: BloqueioHorarioEspecifico[]) {
        this.listaBloqueios = newValue;
      },
      deep: true,
    },
    tipoBloqueioFiltro() {
      this.paginaAtual = 1;
    },
  },
  data() {
    return {
      carregando: false,
      modalBloqueios: false,
      bloqueio: new BloqueioHorarioEspecifico(),
      listaBloqueios: [] as BloqueioHorarioEspecifico[],
      editarBloqueio: false,
      indexBloqueioEditando: -1,
      tipoBloqueioFiltro: null as number | null,
      itensPorPagina: 5,
      paginaAtual: 1,
      optionsTipoBloqueio: [
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Almoco], value: TipoBloqueioHorario.Almoco },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Reuniao], value: TipoBloqueioHorario.Reuniao },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.ConsultaExterna], value: TipoBloqueioHorario.ConsultaExterna },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Treinamento], value: TipoBloqueioHorario.Treinamento },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Procedimento], value: TipoBloqueioHorario.Procedimento },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Intervalo], value: TipoBloqueioHorario.Intervalo },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Outro], value: TipoBloqueioHorario.Outro },
      ],
      optionsTipoBloqueioFiltro: [
        { text: 'Todos', value: null },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Almoco], value: TipoBloqueioHorario.Almoco },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Reuniao], value: TipoBloqueioHorario.Reuniao },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.ConsultaExterna], value: TipoBloqueioHorario.ConsultaExterna },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Treinamento], value: TipoBloqueioHorario.Treinamento },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Procedimento], value: TipoBloqueioHorario.Procedimento },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Intervalo], value: TipoBloqueioHorario.Intervalo },
        { text: TipoBloqueioHorarioLabels[TipoBloqueioHorario.Outro], value: TipoBloqueioHorario.Outro },
      ],
      quantidadeItens: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      colunasBloqueios: [
        { text: 'Tipo', value: 'tipoBloqueio', sortable: false },
        { text: 'Data', value: 'data', sortable: false },
        { text: 'Horário', value: 'horarioInicio', sortable: false },
        { text: 'Duração', value: 'duracao', sortable: false },
        { text: 'Descrição', value: 'descricao', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      headerProps: {
        'sort-by-text': 'Ordenar por',
      },
    };
  },
  computed: {
    tituloBloqueios(): string {
      return this.editarBloqueio ? 'Editar Bloqueio de Horário' : 'Novo Bloqueio de Horário';
    },
    iconeTituloBloqueios(): string {
      return this.editarBloqueio ? 'mdi-pencil' : 'mdi-plus';
    },
    listaBloqueiosFiltrados(): BloqueioHorarioEspecifico[] {
      if (this.tipoBloqueioFiltro === null) {
        return this.listaBloqueios;
      }
      return this.listaBloqueios.filter((bloqueio) => bloqueio.tipoBloqueio === this.tipoBloqueioFiltro);
    },
    totalPaginas(): number {
      return Math.ceil(this.listaBloqueiosFiltrados.length / this.itensPorPagina);
    },
    listaBloqueiosFiltradosPaginados(): BloqueioHorarioEspecifico[] {
      const start = (this.paginaAtual - 1) * this.itensPorPagina;
      const end = start + this.itensPorPagina;
      return this.listaBloqueiosFiltrados.slice(start, end);
    },
    regrasDescricao() {
      if (this.bloqueio.tipoBloqueio === 6) {
        return { required: true, max: 45 };
      }
      return { max: 45 };
    },
  },
  mounted() {
    this.listaBloqueios = this.value;
  },
  methods: {
    formatarTipoBloqueio(tipo: TipoBloqueioHorario): string {
      return TipoBloqueioHorarioLabels[tipo] || 'Outro';
    },
    formatarData(data: string): string {
      if (data && data.includes('-') && data.split('-').length === 3) {
        const partes = data.split('-');
        if (partes[0].length === 4) {
          return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
      }
      return DateHelper.formataParaDiaMesAno(data);
    },
    abrirModalBloqueios() {
      this.bloqueio = new BloqueioHorarioEspecifico();
      const hoje = new Date();
      const [dataAtual] = hoje.toISOString().split('T');
      this.bloqueio.data = dataAtual;
      this.editarBloqueio = false;
      this.modalBloqueios = true;
    },
    abrirModalBloqueiosParaEdicao(item: BloqueioHorarioEspecifico) {
      this.bloqueio = { ...item };
      if (item.data && item.data.includes('T')) {
        const [dataFormatada] = item.data.split('T');
        this.bloqueio.data = dataFormatada;
      } else if (item.data && item.data.includes('/')) {
        const [dia, mes, ano] = item.data.split('/');
        this.bloqueio.data = `${ano}-${mes}-${dia}`;
      } else {
        this.bloqueio.data = item.data;
      }
      this.editarBloqueio = true;
      this.indexBloqueioEditando = this.listaBloqueios.findIndex((b: any) => b.id === item.id);
      this.modalBloqueios = true;
    },
    async excluirBloqueio(item: BloqueioHorarioEspecifico) {
      const confirmacao = await AlertaExclusaoQuestaoBooleano();
      if (confirmacao) {
        const index = this.listaBloqueios.indexOf(item);
        if (index > -1) {
          this.listaBloqueios.splice(index, 1);
          this.$emit('input', this.listaBloqueios);
          MensagemMixin(3000, 'success', 'Bloqueio de horário excluído com sucesso!');
        }
      }
    },
    async salvar() {
      const valid = await (this.$refs.observerBloqueios as any).validate();
      if (!valid) {
        MensagemMixin(5000, 'warning', 'Preencha todos os campos obrigatórios!');
        return;
      }

      const [ano, mes, dia] = this.bloqueio.data.split('-');
      const [hora, minuto] = this.bloqueio.horarioInicio.split(':');
      const dataHorarioBloqueio = new Date(
        Number(ano),
        Number(mes) - 1,
        Number(dia),
        Number(hora),
        Number(minuto),
      );
      const agora = new Date();

      if (dataHorarioBloqueio < agora) {
        MensagemMixin(
          5000,
          'error',
          'A data e horário do bloqueio não podem ser no passado!',
        );
        return;
      }
      const horarioInicio = this.bloqueio.horarioInicio.split(':');
      const duracao = this.bloqueio.duracao.split(':');

      const inicioMinutos = parseInt(horarioInicio[0], 10) * 60 + parseInt(horarioInicio[1], 10);
      const duracaoMinutos = parseInt(duracao[0], 10) * 60 + parseInt(duracao[1], 10);
      const fimMinutos = inicioMinutos + duracaoMinutos;

      const meiaNoiteMinutos = 24 * 60;

      if (fimMinutos > meiaNoiteMinutos) {
        const duracaoMaximaMinutos = meiaNoiteMinutos - inicioMinutos;
        const duracaoMaximaHoras = Math.floor(duracaoMaximaMinutos / 60);
        const duracaoMaximaMinutosRestantes = duracaoMaximaMinutos % 60;
        let duracaoTexto = '';
        if (duracaoMaximaHoras > 0 && duracaoMaximaMinutosRestantes > 0) {
          duracaoTexto = `${duracaoMaximaHoras} hora${duracaoMaximaHoras > 1 ? 's' : ''} e ${duracaoMaximaMinutosRestantes} minuto${duracaoMaximaMinutosRestantes > 1 ? 's' : ''}`;
        } else if (duracaoMaximaHoras > 0) {
          duracaoTexto = `${duracaoMaximaHoras} hora${duracaoMaximaHoras > 1 ? 's' : ''}`;
        } else {
          duracaoTexto = `${duracaoMaximaMinutosRestantes} minuto${duracaoMaximaMinutosRestantes > 1 ? 's' : ''}`;
        }

        MensagemMixin(
          8000,
          'error',
          `O bloqueio não pode ultrapassar a meia-noite! Para o horário de início ${this.bloqueio.horarioInicio}, a duração máxima permitida é ${duracaoTexto}.`,
        );
        return;
      }

      if (this.agenda && this.agenda.listaFeriados && this.agenda.listaFeriados.length > 0) {
        const normalizarData = (dataStr: string): Date => {
          if (!dataStr) return new Date();
          let data: Date;
          if (dataStr.includes('/') && dataStr.split('/').length === 3) {
            const [dia, mes, ano] = dataStr.split('/');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else if (dataStr.includes('-') && dataStr.split('-').length === 3) {
            const [ano, mes, dia] = dataStr.split('-');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else {
            data = new Date(dataStr);
          }
          if (Number.isNaN(data.getTime())) {
            return new Date();
          }
          return new Date(data.getFullYear(), data.getMonth(), data.getDate());
        };

        const dataBloqueioDia = normalizarData(this.bloqueio.data);

        let feriadoNoDia: any = null;
        let dataFeriadoFormatada = '';

        const feriadoEncontrado = this.agenda.listaFeriados.find((feriado: any) => {
          const dataFeriadoDia = normalizarData(feriado.data);
          if (dataFeriadoDia.getTime() === dataBloqueioDia.getTime()) {
            feriadoNoDia = feriado;
            const dia = String(dataFeriadoDia.getDate()).padStart(2, '0');
            const mes = String(dataFeriadoDia.getMonth() + 1).padStart(2, '0');
            const ano = dataFeriadoDia.getFullYear();
            dataFeriadoFormatada = `${dia}/${mes}/${ano}`;
            return true;
          }
          return false;
        });

        if (feriadoEncontrado && feriadoNoDia) {
          MensagemMixin(5000, 'error', `Não é possível criar bloqueio de horário. Existe um feriado neste dia: ${dataFeriadoFormatada} - ${feriadoNoDia.descricao}. Remova o feriado primeiro.`);
          return;
        }
      }

      if (this.editarBloqueio) {
        this.listaBloqueios.splice(this.indexBloqueioEditando, 1, { ...this.bloqueio });
        MensagemMixin(3000, 'success', 'Bloqueio de horário editado com sucesso!');
      } else {
        this.listaBloqueios.push({ ...this.bloqueio });
        MensagemMixin(3000, 'success', 'Bloqueio de horário adicionado com sucesso!');
      }

      this.$emit('input', this.listaBloqueios);
      this.fecharModal();
    },
    fecharModal() {
      this.modalBloqueios = false;
      this.bloqueio = new BloqueioHorarioEspecifico();
      this.editarBloqueio = false;
      this.indexBloqueioEditando = -1;
    },
  },
});
</script>

<style scoped>
.botao-novo {
  display: flex;
  justify-content: flex-start;
  padding: 16px;
}

.btn-novo-bloqueio {
  background-color: var(--especialidade-primary) !important;
  color: white !important;
  font-weight: 500;
}

.bloqueio-modal-container {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  padding: 24px;
  color: white;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 4px 0 0 0;
}

.unified-content {
  background-color: #f5f5f5;
}

.unified-card {
  box-shadow: none !important;
}

.form-content {
  padding: 24px;
  background-color: white;
  max-height: 60vh;
  overflow-y: auto;
}

.form-actions {
  background-color: #f5f5f5;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  min-width: 120px;
  font-weight: 500;
}

.cancel-btn {
  background-color: #ff9800 !important;
  color: white !important;
}

.save-btn {
  background-color: #1976d2 !important;
  color: white !important;
}
</style>
